import { Link } from 'react-router-dom';
import { JournalEntry } from '../../types/journal';
import { TimelineSummary } from './TimelineSummary';

interface EntryDetailProps {
  entry: JournalEntry;
}

function formatDateTime(isoString: string): string {
  const date = new Date(isoString);
  return date.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

export function EntryDetail({ entry }: EntryDetailProps) {
  const hasTimingData =
    entry.onsetMinutes != null ||
    entry.peakMinutes != null ||
    entry.durationMinutes != null;

  return (
    <div className="entry-detail">
      <h2>Journal Entry</h2>

      <dl className="entry-detail-fields">
        <div className="entry-detail-field">
          <dt>Date &amp; Time</dt>
          <dd>{formatDateTime(entry.consumedAt)}</dd>
        </div>

        <div className="entry-detail-field">
          <dt>Serving Size</dt>
          <dd>{entry.servingSize}</dd>
        </div>

        <div className="entry-detail-field">
          <dt>Cannabinoid Type</dt>
          <dd>{entry.cannabinoidType}</dd>
        </div>

        <div className="entry-detail-field">
          <dt>Cannabinoid Amount</dt>
          <dd>{entry.cannabinoidMg} mg</dd>
        </div>

        {entry.recipeName != null && entry.recipeId != null && (
          <div className="entry-detail-field">
            <dt>Recipe</dt>
            <dd>
              <Link to={`/recipes/${entry.recipeId}`}>{entry.recipeName}</Link>
            </dd>
          </div>
        )}

        {entry.recipeName != null && entry.recipeId == null && (
          <div className="entry-detail-field">
            <dt>Recipe</dt>
            <dd>{entry.recipeName}</dd>
          </div>
        )}

        {hasTimingData && (
          <div className="entry-detail-field">
            <dt>Timeline</dt>
            <dd>
              <TimelineSummary
                onset={entry.onsetMinutes ?? null}
                peak={entry.peakMinutes ?? null}
                duration={entry.durationMinutes ?? null}
              />
            </dd>
          </div>
        )}

        {entry.effects != null && entry.effects.length > 0 && (
          <div className="entry-detail-field">
            <dt>Effects</dt>
            <dd>
              <ul className="entry-detail-effects" aria-label="Effects list">
                {entry.effects.map((effect) => (
                  <li key={effect} className="entry-detail-effect-tag">
                    {effect}
                  </li>
                ))}
              </ul>
            </dd>
          </div>
        )}

        {entry.notes != null && (
          <div className="entry-detail-field">
            <dt>Notes</dt>
            <dd>{entry.notes}</dd>
          </div>
        )}

        {entry.rating != null && (
          <div className="entry-detail-field">
            <dt>Rating</dt>
            <dd>{entry.rating}/5</dd>
          </div>
        )}
      </dl>
    </div>
  );
}
